import { MATRIX_BACKEND } from '@/remotes';
import { useNewDataFormCargoPickUpStore } from '@/stores/newFormCargoPickUp';

const defaultParams = {
  Length: 10,
  Width: 10,
  Height: 10,
  Weight: 10,
  declaredValue: 3000,
};

const checkRequiredSelected = (fetched, selected) => {
  const fetchHasRequired = Boolean(fetched.find((el) => el.isRequired));
  if (fetchHasRequired) {
    const selectedHasRequired = Boolean(selected.find((el) => el.isRequired));
    if (!selectedHasRequired) {
      return false;
    }
  }
  return true;
};

export async function useFetchExtraPackaging(changeSelectedExtraPackaging = false) {
  const dataForm = useNewDataFormCargoPickUpStore();

  const { cargoInformation } = dataForm;

  const natureOfCargoId = cargoInformation.natureOfCargo?.id;

  const params = new URLSearchParams();

  const { id: cargoType } = cargoInformation.typeOfCargo;

  params.append('cargoType', cargoType);

  switch (cargoType) {
    case 1:
      if (dataForm.getIsValidStandard && natureOfCargoId) {
        params.append('DeclaredValue', Number(cargoInformation.cargoCost));
        params.append('CargoNaturesId', natureOfCargoId);

        if (changeSelectedExtraPackaging) {
          cargoInformation.typeOfPackaging.forEach((el) => params.append('SelectedPackaging', Number(el.id)));
        }

        params.append('Weight', Number(cargoInformation.cargoWeight));
        params.append('Height', Number(cargoInformation.cargoDimensions.height));
        params.append('Length', Number(cargoInformation.cargoDimensions.length));
        params.append('Width', Number(cargoInformation.cargoDimensions.width));
        try {
          dataForm.requestPendingForPackaging = true;
          const { data } = await MATRIX_BACKEND.get('/api/public/available-packaging', { params });
          cargoInformation.typeOfPackaging = data.filter((el) => el.isSelected);
          dataForm.fetchedExtraPackaging = data;
        } catch {
          dataForm.fetchedExtraPackaging = [];
        } finally {
          dataForm.requestPendingForPackaging = false;
        }
        return;
      }
      break;
    case 2:
      if (dataForm.getIsValidCylinder && natureOfCargoId) {
        params.append('DeclaredValue', cargoInformation.cargoCost);
        params.append('CargoNaturesId', natureOfCargoId);

        if (changeSelectedExtraPackaging) {
          cargoInformation.typeOfPackaging.forEach((el) => params.append('SelectedPackaging', Number(el.id)));
        }

        params.append('Weight', Number(cargoInformation.cargoWeight));
        params.append('Diameter', Number(cargoInformation.sizeOfCargoCylinder.diameter));
        params.append('Height', Number(cargoInformation.sizeOfCargoCylinder.height));
        try {
          dataForm.requestPendingForPackaging = true;
          const { data } = await MATRIX_BACKEND.get('/api/public/available-packaging', { params });
          cargoInformation.typeOfPackaging = data.filter((el) => el.isSelected);
          dataForm.fetchedExtraPackaging = data;
        } catch {
          dataForm.fetchedExtraPackaging = [];
        } finally {
          dataForm.requestPendingForPackaging = false;
        }
        return;
      }
      break;
    case 3:
      params.append('DeclaredValue', cargoInformation.cargoCost);
      params.append('CargoNaturesId', 74);
      if (changeSelectedExtraPackaging) {
        cargoInformation.typeOfPackaging.forEach((el) => params.append('SelectedPackaging', Number(el.id)));
      }
      try {
        dataForm.requestPendingForPackaging = true;
        const { data } = await MATRIX_BACKEND.get('/api/public/available-packaging', { params });
        cargoInformation.typeOfPackaging = data.filter((el) => el.isSelected);
        dataForm.fetchedExtraPackaging = data;
      } catch {
        dataForm.fetchedExtraPackaging = [];
      } finally {
        dataForm.requestPendingForPackaging = false;
      }
      return;

    default:
      break;
  }

  Object.keys(defaultParams).forEach((key) => params.append(key, defaultParams[key]));

  try {
    const cachedPackaging = dataForm.cachedFetchedExtraPackaging;
    cargoInformation.typeOfPackaging = [];
    if (cachedPackaging) {
      dataForm.fetchedExtraPackaging = cachedPackaging;
      return;
    }
    dataForm.requestPendingForPackaging = true;
    const { data } = await MATRIX_BACKEND.get('/api/public/available-packaging', { params });
    dataForm.fetchedExtraPackaging = data;
    dataForm.cachedFetchedExtraPackaging = data;
  } catch {
    dataForm.fetchedExtraPackaging = [];
    dataForm.cachedFetchedExtraPackaging = [];
  } finally {
    dataForm.requestPendingForPackaging = false;
  }
}
